import React, { Component } from 'react'
import Loadable from 'react-loadable'
import { Switch, Route, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import styled, { ThemeProvider } from 'styled-components'

import Container from 'modules/common/components/ui/Container'
import AppHeader from 'modules/common/components/app/AppHeader'
import AppFooter from 'modules/common/components/app/AppFooter'

import CookiesPolicy from 'modules/common/components/app/CookiesPolicy'
import { getSeoForPage } from './seo'

import Modal from 'modules/common/components/modal/Modal'
import AreaSelect from 'modules/common/components/areaselect'
import themes from 'modules/common/components/ui/themes'

import PageLoading from 'modules/common/components/pageloading'

import BookingPage from 'modules/pages/BookingPage'
import SetsterBookingPage from 'modules/pages/SetsterBookingPage'

import { APP_THEME } from 'config'

const L = opts => Loadable({
  loading: PageLoading,
  delay: 300,
  ...opts,
})

const AsyncHome = L({
  loader: () => import('containers/HomePageContainer'),
})

const EmbedCalendarPage = L({
  loader: () => import('modules/pages/EmbedCalendarPage'),
})

const Search = L({
  loader: () => import('modules/search/components/Search'),
})


const Introduction = L({
  loader: () => import('modules/common/components/app/Introduction'),
})

const SearchResultsPage = L({
  loader: () => import('modules/pages/SearchResultsPage'),
})

const CoursesMapPage = L({
  loader: () => import('containers/CourseMapPageContainer'),
})

const ProsListPage = L({
  loader: () => import('modules/pages/ProsListPage'),
})

const ContactPage = L({
  loader: () => import('modules/pages/ContactPage'),
})

const HelpPage = L({
  loader: () => import('modules/pages/HelpPage'),
})

const TermsPage = L({
  loader: () => import('modules/pages/TermsPage'),
})

const LecturesPage = L({
  loader: () => import('modules/pages/LecturesPage'),
})

const LecturesListPage = L({
  loader: () => import('modules/pages/LecturesListPage'),
})

const InfoPage = L({
  loader: () => import('modules/pages/InfoPage'),
})

const GroupLessonsPage = L({
  loader: () => import('modules/pages/GroupLessonsPage'),
})

const CookiesPolicyPage = L({
  loader: () => import('modules/pages/CookiesPolicyPage'),
})

const DemoList = L({
  loader: () => import('modules/pages/DemoList'),
})

const VoucherPage = L({
  loader: () => import('modules/pages/VoucherPage'),
})

const PurchaseVoucherPage = L({
  loader: () => import('modules/pages/PurchaseVoucherPage'),
})

const AsyncPro = L({
  loader: () => import('containers/ProPageContainer'),
})

const AsyncClub = L({
  loader: () => import('containers/CoursePageContainer'),
})

const AsyncEvent = L({
  loader: () => import('containers/EventPageContainer'),
})

const AsyncService = L({
  loader: () => import('containers/ServicePageContainer'),
})

const AsyncProList = L({
  loader: () => import('modules/pages/ProsPage'),
})

const AsyncTeetimeBooking = L({
  loader: () => import('containers/TeetimeBookingContainer'),
})

const eventsPath = '/:list(lectures|events|trips|services)';
const eventPath = `${eventsPath}/:id(\\d+)`;
const bookingPath = `${eventPath}/book/:priceid(\\d+)?`;

const prosPath = '/pros';
const proPath = `${prosPath}/:machine_name`;
const proReservationPath = `${proPath}/book/:serviceId/:time`;

const RootContainer = styled.div``;

const SearchWrapper = styled.div`padding: 1rem 0 3rem;`;

class App extends Component {
  _seoData;
  state = {
    menuOpen: false,
    isSearchModalOpen: false,
  };

  //previousLocation = this.props.location
  componentWillMount() {
    const { location } = this.props;
    // set previousLocation if props.location is not modal
    if (
      location.state &&
      !location.state.modal
      //(!location.state || !location.state.modal)
    ) {
      this.previousLocation = this.props.location;
    }

    this._seoData = getSeoForPage('home');
  }

  componentWillUpdate(nextProps) {
    const { location } = this.props;
    // set previousLocation if props.location is not modal
    if (
      nextProps.history.action !== 'POP' &&
      (!location.state || !location.state.modal)
    ) {
      this.previousLocation = this.props.location;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      this.closeMenu();
      this.closeSearchModal();
    }
  }

  openMenu = () => {
    this.setState({
      menuOpen: true,
    });
  };

  closeMenu = () => {
    if (!this.state.menuOpen) return;
    this.setState({
      menuOpen: false,
    });
  };

  toggleMenu = event => {
    event.preventDefault();
    this.setState({
      menuOpen: !this.state.menuOpen,
    });
  }

  handleMenuOpenClick = () => {
    this.openMenu();
  };

  handleMenuCloseClick = () => {
    this.closeMenu();
  };

  handleCloseSearchModal = () => {
    this.closeSearchModal();
  };

  handleSearchClick = () => {
    this.openSearchModal();
  };

  _handleNotificationClose = () => {
    this._closeNotification();
  };

  _closeNotification = () => {
    if (!this.state.isCountryNotificationOpen) return;
    this.setState({
      isCountryNotificationOpen: false,
    });
  };

  closeSearchModal = () => {
    if (!this.state.isSearchModalOpen) return;
    this.setState({
      isSearchModalOpen: false,
    });
    document.body.classList.remove('with-modal');
  };

  openSearchModal = () => {
    this.setState({
      isSearchModalOpen: true,
    });
    document.body.classList.add('with-modal');
  };
  /*
  _shouldSearchBeRendered(location) {
    return location.pathname.match(/^\/grouplessons/);
  }
*/
  // handleUserClick = () => {
  //   this.props.history.push('/user/login', {modal:true});
  // }

  _renderFullPage() {
    const { location } = this.props;
    //const { pathname } = location;

    const isModal = !!(
      location.state &&
      location.state.modal &&
      this.previousLocation !== location
    ); // not initial render

    const modalShouldAnimateEnter = this.previousLocation !== location;
    //const shouldRenderFooter = pathname !== '/';

    return (
      <RootContainer menuOpen={this.state.menuOpen}>
        <Helmet title={this._seoData.title} meta={this._seoData.meta} />
        <ThemeProvider theme={themes[APP_THEME]}>
          <AppHeader
            toggleMenu={this.toggleMenu}
            menuOpen={this.state.menuOpen}
            onMenuOpenClick={this.handleMenuOpenClick}
            onSearchClick={this.handleSearchClick}
            onUserClick={this.handleUserClick}
          />
        </ThemeProvider>
        <ThemeProvider theme={themes[APP_THEME]}>
          <Container>
            <Switch location={isModal ? this.previousLocation : location}>
              <Route exact path="/" component={AsyncHome} />
              <Route exact path="/introduction" component={AsyncHome} />

              <Route exact path="/help" component={HelpPage} />

              <Route exact path="/terms" component={TermsPage} />

              <Route exact path="/contact" component={ContactPage} />

              <Route path="/events/:id" component={AsyncEvent} />
              
              <Route path="/services/:id" component={AsyncService} />

              <Route exact path="/courses" component={CoursesMapPage} />

              <Route
                exact
                path="/courses/:id"
                component={AsyncClub}
              />
              <Route
                exact
                path="/courses/:id/teetime/book/:golf18id/:teetimeid/:time/:booking_state?"
                component={AsyncTeetimeBooking}
              />
              <Route exact path="/pros" component={AsyncProList} />
              <Route exact path="/pros/list" component={ProsListPage} />
              <Route path="/pros/:id" component={AsyncPro} />

              <Route
                path="/search"
                render={() => (
                  <SearchResultsPage onSearchClick={this.handleSearchClick} />
                )}
              />

              <Route exact={true} path="/gift-cards" component={VoucherPage} />
              <Route
                path="/gift-cards/purchase"
                component={PurchaseVoucherPage}
              />

              <Route exact path="/lectures" component={LecturesPage} />
              <Route exact path="/lectures/list" component={LecturesListPage} />

              <Route exact path="/info" component={InfoPage} />
              <Route exact path="/grouplessons" component={GroupLessonsPage} />
              <Route exact path="/cookies-policy" component={CookiesPolicyPage} />
              <Route exact path="/list/:type" component={DemoList} />
            </Switch>
            <Route path="/:path(|/|gift-cards|contact|courses|pros|services|events)" component={AppFooter} />
            <CookiesPolicy cookiePageHref="/cookies-policy" />
          </Container>
        </ThemeProvider>

        <Route
          path={eventPath}
          render={({ match, location }) => (
            <ReactCSSTransitionGroup
              component="div"
              transitionName="modal"
              transitionAppear={modalShouldAnimateEnter}
              transitionAppearTimeout={350}
              transitionEnter={modalShouldAnimateEnter}
              transitionEnterTimeout={350}
              transitionLeaveTimeout={350}
            >
              <Route
                location={location}
                match={match}
                key={location.pathname.split('/')[3] || 'root'}
                path={bookingPath}
                render={props => (
                  <BookingPage {...props} onCloseLink={this.previousLocation} />
                )}
              />
            </ReactCSSTransitionGroup>
          )}
        />

        <Route
          path={proPath}
          render={({ match, location }) => (
            <ReactCSSTransitionGroup
              component="div"
              transitionName="modal"
              transitionAppear={modalShouldAnimateEnter}
              transitionAppearTimeout={350}
              transitionEnter={modalShouldAnimateEnter}
              transitionEnterTimeout={350}
              transitionLeaveTimeout={350}
            >
              <Route
                location={location}
                match={match}
                key={location.pathname.split('/')[3] || 'root'}
                path={proReservationPath}
                render={props => (
                  <SetsterBookingPage
                    {...props}
                    onCloseLink={this.previousLocation}
                  />
                )}
              />
            </ReactCSSTransitionGroup>
          )}
        />

        <Route
          path="/introduction"
          render={({ match, location }) => (
            <ReactCSSTransitionGroup
              component="div"
              transitionName="modal"
              transitionAppear={modalShouldAnimateEnter}
              transitionAppearTimeout={350}
              transitionEnter={modalShouldAnimateEnter}
              transitionEnterTimeout={350}
              transitionLeaveTimeout={350}
            >
              <Route
                path="/introduction"
                component={Introduction}
              />
            </ReactCSSTransitionGroup>
          )}
        />
        <Modal
          isOpen={this.state.isSearchModalOpen}
          onClose={this.handleCloseSearchModal}
          title="Haku"
        >
          <ThemeProvider theme={themes[APP_THEME]}>
            <SearchWrapper>
              <Search extended onCancelClick={this.handleCloseSearchModal} />
            </SearchWrapper>
          </ThemeProvider>
        </Modal>
        <AreaSelect
          onClose={this._handleNotificationClose}
        />
      </RootContainer>
    );
  }

  _renderEmbedContent() {
    const { location } = this.props;
    
    const modalShouldAnimateEnter = this.previousLocation !== location;

    const _proPath = `/embed/pros/:id`;
    const _proReservationPath = `${_proPath}/book/:serviceId/:time`;

    const CalendarEmbedContainer = styled.div`
      padding: 0;
      margin: 0;
      width: 100%;
      max-width: 980px;
      box-sizing: border-box;
    `;

    return (
      <ThemeProvider theme={themes[APP_THEME]}>
        <CalendarEmbedContainer>
          <Route path="/embed/calendar/:id" component={EmbedCalendarPage} />
          <Route
            path={_proPath}
            render={({ match, location }) => (
              <ReactCSSTransitionGroup
                component="div"
                transitionName="modal"
                transitionAppear={modalShouldAnimateEnter}
                transitionAppearTimeout={350}
                transitionEnter={modalShouldAnimateEnter}
                transitionEnterTimeout={350}
                transitionLeaveTimeout={350}
              >
                <Route
                  location={location}
                  match={match}
                  key={location.pathname.split('/')[3] || 'root'}
                  path={_proReservationPath}
                  // render={(props) => <ReservationTimeModal {...props} onCloseLink={this.previousLocation} />}
                  render={props => (
                    <SetsterBookingPage
                      {...props}
                      onCloseLink={this.previousLocation}
                    />
                  )}
                />
              </ReactCSSTransitionGroup>
            )}
          />
        </CalendarEmbedContainer>
      </ThemeProvider>
    );
  }

  render() {
    const { location } = this.props;

    const isEmbed = location.pathname.match(/^\/embed\/(.*)/);

    if (isEmbed) {
      return this._renderEmbedContent();
    } else {
      return this._renderFullPage();
    }
  }
}

const mapStateToProps = state => {
  const { search: { query } } = state;

  return {
    query,
  };
};

const ConnectedApp = withRouter(connect(mapStateToProps)(App));

export default ConnectedApp;



// WEBPACK FOOTER //
// ./src/modules/App.js